import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './about.css';
import './fonts.css';

function About() {
    return (
        <div className="aboutBackground">
            <div className="row">
                <div className="col-7 col-md-3 col-lg-3">
                    <img src='https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918890/aboutme_l7y30a.jpg' alt="preview thumbnails" className='aboutSelfie' />
                </div>
                <div className="col-sm-7 col-md-9 col-lg-9">
                    <span className='aboutTitle'>
                            Hey there! 
                        <br />
                    </span>
                    <p className='aboutText'>
                        I’m Iuliana. I’m so glad you’re here.  <br /><br />

                        I was never good at saying nice things about myself. I tend to create a negative image of who I am, but I’m glad that others see me differently. They say I’m a beautiful person, inside and out. Most of the time I don’t believe them, maybe 95% of the time. But when I do, I build things like this website or I do photoshoots and create content.
                        <br /> <br /> There’s a quote I really like, and before I add anything else about myself, I want to share it with you. Here it is:
                        <blockquote className="aboutQuote">
                            “Choose a job you love, and you will never have to work a day in your life.”
                            <br /> – Confucius
                        </blockquote>
                        This quote really sums up how I feel about the things I do. I love programming. It’s one of those things that I find both fascinating and a pain in the ass. Sometimes it gives me headaches, but when I finally figure it out, the satisfaction is better than any chocolate or, I don’t know, any sparkly piece of jewelry.
                        <br /> <br /> I also love creating content. Behind everything I capture, there’s already a version in my head, processed in my style. I usually see right away how something should look or what filter I should add to give it my personal touch. That’s what passion looks like. Sometimes I wish I had more time for this, because there are so many beautiful places, people, and ideas that it feels like one lifetime isn’t enough to capture them all. But I promise you, I’m giving it my all.
                        <br /> <br /> As if those two weren’t enough, I also love discovering and trying new things. Guess what I’ve been up to? A few days ago I was looking for a guitar. It’s part of an old teenage dream I had — to sing. I still don’t know if this is a crazy idea or a great one, but I’m sure I’ll give it a try. We’ll see if I ever post anything about it. I guess it depends on how bad it sounds.
                        <br /> <br /> To be continued… because the story’s not over yet...
                    </p>

                </div>
            </div>
        </div>
    );
}

export default About;